import { IDesigner } from "../types";

export const fetchDesigner = (id: string): Promise<IDesigner> =>
  fetch(`/museo/json/designer-${id}.json`).then((response) => response.json());
